<template>
  <Modal
    title="结算"
    v-model="settlementVisible"
    width="500px"
    class-name="commissionRecordModal"
    class="my-modal"
    :mask-closable="false"
  >
    <Form
      ref="settlementFormRef"
      :model="settlementForm"
      class="page-form formGauge"
      :rules="settlementFormRules"
      :label-width="110"
      inline
    >
      <FormItem prop="checkId" class="full" label="我司批次名称">
        <Select
          v-model="settlementForm.checkId"
          not-found-text="暂无数据，请生成结算批次后结算"
          clearable
          @on-change="selectBatch(settlementForm, $event)"
          transfer
        >
          <Option
            :value="item.id"
            v-for="(item, i) in batchList"
            :key="i"
            :label="item.checkName"
          ></Option>
        </Select>
      </FormItem>
      <FormItem prop="checkDate" class="full" label="结算日期">
        <DatePicker
          format="yyyy-MM-dd"
          disabled
          v-model="settlementForm.checkDate"
          type="date"
          placeholder="请选择"
          :transfer="true"
        ></DatePicker>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button type="primary" @click="settlementVisible = false" ghost
        >取消</Button
      >
      <Button type="primary" @click="saveSettlement()">确认</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  data() {
    return {
      settlementVisible: false,
      settlementForm: {
        checkId: "",
        checkDate: "",
      },
      settlementFormRules: {
        checkId: [
          {
            required: true,
            message: "请选择我司批次",
            trigger: "change",
          },
        ],
        checkDate: [
          {
            required: true,
            message: "请选择结算日期",
            type: "date",
            trigger: "change",
          },
        ],
      },
      batchList: [],
    };
  },
  created() {},

  methods: {
    saveSettlement() {
      this.settlementForm.type = "2";
      this.$refs["settlementFormRef"].validate((valid) => {
        if (valid) {
          this.$http({
            url: "/buz/commissionLog/batchAcceptCommission",
            type: "POST",
            data: this.settlementForm,
            apiPermissionCode:'offline_9_3'
          }).then((res) => {
            if (res.httpCode == 1) {
              this.$Message.success("操作成功");
              this.$emit('getList')
            }
            this.settlementVisible = false;
          });
        }
      });
    },
    // 获取所有批次
    getCheckNo(type) {
      this.$http({
        url: "/buz/molCommissionCheck/read/allCheckNo",
        type: "POST",
        data:{
          source: type == 1?'1':'2',
          commissionIndex:'1'
        }
      }).then((res) => {
        this.batchList = res.data;
      });
    },
    selectBatch(formData, id) {
      const data = this.batchList.find((item) => {
        return item.id == id;
      });
      this.$set(formData, "checkDate", data.checkDate);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>    